module.exports = __webpack_public_path__ + "assets/f8fe8c73a4c8c2ab301f5f7dbcbbe697.mp3";